import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var ActivateVipAction;
(function (ActivateVipAction) {
    ActivateVipAction["REQUEST"] = "ACTIVATE_VIP_REQUEST";
    ActivateVipAction["SUCCESS"] = "ACTIVATE_VIP_SUCCESS";
    ActivateVipAction["ERROR"] = "ACTIVATE_VIP_ERROR";
    ActivateVipAction["RESET"] = "RESET_ACTIVATE_VIP";
})(ActivateVipAction || (ActivateVipAction = {}));
export function resetActivateVip() {
    return (dispatch) => {
        dispatch({
            type: ActivateVipAction.RESET
        });
    };
}
export function fetchActivateVipRequest(previousPageType) {
    const params = {
        pageUri: '',
        actionRequestContext: {
            type: 'USER_ACTIVATE',
            previousPageType
        }
    };
    return (dispatch) => {
        dispatch({
            type: ActivateVipAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/action/view',
            acceptErrors: true,
            action: ActivateVipAction.REQUEST
        }), params).then(json => dispatch({
            type: ActivateVipAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: ActivateVipAction.ERROR,
                error
            });
        });
    };
}
// This gets used in lockin v2 version
export var RewardTokenAction;
(function (RewardTokenAction) {
    RewardTokenAction["REQUEST"] = "GET_REWARD_TOKEN_REQUEST";
    RewardTokenAction["SUCCESS"] = "GET_REWARD_TOKEN_SUCCESS";
    RewardTokenAction["ERROR"] = "GET_REWARD_TOKEN_ERROR";
    RewardTokenAction["RESET"] = "RESET_REWARD_TOKEN";
})(RewardTokenAction || (RewardTokenAction = {}));
export function resetRewardToken() {
    return (dispatch) => {
        dispatch({
            type: RewardTokenAction.RESET
        });
    };
}
export function fetchRewardTokenRequest(params) {
    return (dispatch) => {
        dispatch({
            type: RewardTokenAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/digital/token',
            action: RewardTokenAction.REQUEST
        }), params).then(json => dispatch({
            type: RewardTokenAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: RewardTokenAction.ERROR,
                error
            });
        });
    };
}
export var ClaimRewardAction;
(function (ClaimRewardAction) {
    ClaimRewardAction["REQUEST"] = "CLAIM_REWARD_REQUEST";
    ClaimRewardAction["SUCCESS"] = "CLAIM_REWARD_SUCCESS";
    ClaimRewardAction["ERROR"] = "CLAIM_REWARD_ERROR";
    ClaimRewardAction["RESET"] = "CLAIM_REWARD_RESET";
})(ClaimRewardAction || (ClaimRewardAction = {}));
export function resetRewardClaim() {
    return (dispatch) => {
        dispatch({
            type: ClaimRewardAction.RESET
        });
    };
}
export function fetchClaimRewardRequest(rewardId) {
    const params = {
        pageUri: '',
        actionRequestContext: {
            type: 'CLAIM_REWARD',
            rewardId
        }
    };
    return (dispatch) => {
        dispatch({
            type: ClaimRewardAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/action/view',
            acceptErrors: true,
            action: ClaimRewardAction.REQUEST
        }), params).then(json => dispatch({
            type: ClaimRewardAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            return Promise.reject(error);
        });
    };
}
